import { brandPath } from 'country-configuration/utils/brands/brandPath'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'

export function useParsedBrands() {
	const {
		country: { brands: countryBrands, countryISO, languageISO },
	} = useMasterData()
	const { t } = useLabels()

	const href = `/${countryISO.toLocaleLowerCase()}/${languageISO}/h`

	const parsedBrands = countryBrands.map((brand) => ({
		...brand,
		url: brandPath({
			brandId: brand.id,
			brands: countryBrands,
			translate: t,
			initialPath: href,
		}),
	}))

	return { parsedBrands }
}
